import React from "react";

const STATS = [
  { k: "Precision", v: "Up to 0.05 mm layer" },
  { k: "Turnaround", v: "24–72 hrs typical" },
  { k: "Materials", v: "PLA · PETG · ABS · Resin" },
];

/** Hero stat strip — honest static copy, no counters. */
export default function HeroStatStrip() {
  return (
    <div className="mt-16 grid grid-cols-3 gap-px bg-white/10 border border-white/10 max-w-2xl">
      {STATS.map((s) => (
        <div
          key={s.k}
          className="bg-[#0A0A0C] p-5 sm:p-6"
          data-testid={`hero-stat-${s.k.toLowerCase()}`}
        >
          <div className="font-display text-lg sm:text-xl text-white tracking-tight leading-tight">
            {s.v}
          </div>
          <div className="label-overline mt-3">{s.k}</div>
        </div>
      ))}
    </div>
  );
}
